import React, { Component } from "react";
import {
  reduxForm,
  Form,
  Field
} from "redux-form";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import TextField from "@material-ui/core/TextField";
import compose from "recompose/compose";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
//import momentLocaliser from 'react-widgets/lib/localizers/moment'
import "react-widgets/dist/css/react-widgets.css";
import CircularProgress from '@material-ui/core/CircularProgress';
//Component
//Lib
import { required } from "../../../libs/validation";
//Reducer
import { apiCallRequest } from "../../../reducers/api";
import { getLevel } from "../../../reducers/setting/api";
import { formLevel } from "../../../reducers/ui/mapForm";
import { settingOpenLevel,settingLevelSelect } from "../../../reducers/setting";

//Config
import Configs from "../../../config/config";
const env = process.env.NODE_ENV;

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    minWidth : '200px'
  },
  formControl: {
    margin: theme.spacing.unit
  },
  center:{
    position: 'relative',
    left: '20px'
  }
});

const renderInput = ({
  meta: { touched, error } = {},
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
  />
);

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class LevelDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open : true
    };
  }

  componentWillMount() {
    
    
  }
  componentWillReceiveProps(nextProps) {

    if (this.props.levelForm!==nextProps.levelForm) {
      this.props.initialize({...nextProps.levelForm});
    }
  }
  handleSave = (form) =>{
    //debugger
    this.props.settingOpenLevel(false);
    let formData = {...form};

   
    if (formData.id) {
      delete(formData.password);
      let id = formData.id;delete(formData.id);
      this.props.API_REQUEST({
        url: Configs[env].BACKEND_HOST + "/level/"+id,
        form: {...formData },
        method : "PUT",
        callback: this.handleCancel
      });
    } else {
      this.props.API_REQUEST({
        url: Configs[env].BACKEND_HOST + "/level",
        form: { ...formData},
        method : "POST",
        callback: this.handleCancel
      });
    }
    
  }
  handleCancel = () => {
    //if(data.errorList.length==0){
      this.props.reset();
      this.props.getLevel({
        url: Configs[env].BACKEND_HOST + "/level",
        filter: {}
      });
      this.props.formLevel(null);
      this.props.settingLevelSelect(null);
      this.props.settingOpenLevel(false);
    //}
  }
  render() {
    const { handleSubmit, classes } = this.props;

    return (
      <div style={{ padding: "10px" }}>
        {/*this.props.isLoading && <Loading />*/}
        
          <Dialog
            open={this.props.level_dialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleCancel}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            >
            <DialogTitle id="alert-dialog-slide-title">
                {this.props.levelForm && this.props.levelForm.id ? "EDIT LEVEL" : "ADD LEVEL"}
            </DialogTitle>
            <DialogContent>
            <Form 
                  //style={{ overflowY:"scroll"}}
                  autoComplete={"off"}
                  autoCorrect={"off"}
                  spellCheck={"off"}
                  onSubmit={handleSubmit(this.handleSave.bind(this))}
              >
                <Grid container spacing={16}>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      name='name'
                      component={renderInput}
                      className={styles.textField}
                      label='Level'
                      validate={[required]}
                    />
                  </Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={4}>
                    <DialogActions>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        aria-label="Save"
                        className={styles.button}
                        disabled={this.props.isLoading}
                        type="submit">
                        {this.props.isLoading && <CircularProgress className={classes.center} size={25} thickness={2} />}
                        SAVE
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        aria-label="Close"
                        disabled={this.props.isLoading}
                        className={classNames(styles.button, styles.cssGreen)}
                        onClick={this.handleCancel}
                      >
                        Close
                      </Button>
                    </DialogActions>
                  </Grid>
                </Grid>
              </Form>
            </DialogContent>
            
          </Dialog>
        
      </div>
    );
  }
}
const mapStateToProps = function(state, ownProps) {
  return {
    isLoading: state.ui.isLoading,
    level_selecting : state.setting.level_selecting,
    level_dialog : state.setting.level_dialog,
    levelForm: state.mapForm.levelForm,
  };
};
const mapActionsToProps = {
  API_REQUEST: apiCallRequest,
  settingOpenLevel,settingLevelSelect,
  getLevel,formLevel
};

const enhance = compose(
  reduxForm({
    form: "levelForm",
  }),
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
);
export default enhance(LevelDialog);
